<div class="d-flex align-items-center justify-content-center bold" style="height: 20vh;" *ngIf="!isLoginFailed">
  Logging into the app... please wait.
</div>
<div class="d-flex align-items-center justify-content-center bold" style="height: 20vh;color: #F06459;" *ngIf="isLoginFailed">
  {{errorMessage || 'Something went wrong.'}}
</div>
